import { isEmpty } from 'lodash';

const getPresenceHistoryResponse = (response, previousResponse, page) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const currentPage = response?.currentPage ?? 1;

  let presences = response?.isDataExist ? response?.data : [];

  if (!isEmpty(previousResponse) && page !== 1) {
    presences = [...previousResponse, ...presences];
  }

  return {
    presences,
    totalData,
    totalPage,
    currentPage,
  };
};

export default getPresenceHistoryResponse;
